module.exports = __webpack_public_path__ + "assets/greenInitiative.6699a554.svg";